import { OrderTicket } from "~/v2/components/orderTicket";
import { MultiLegOrderTicketConnector } from "~/v2/components/orderTicket/multiLeg";
import type { OrderLeg } from "../../shared/optionLegs/optionLeg.types";

export interface OrderTicketBodyProps {
  symbol?: string;
  legs: readonly OrderLeg[];
  initialQuantity?: number;
  onRemoveLeg: (contractSymbol: string) => void;
  onUpdateLegType: (contractSymbol: string, type: string) => void;
  onCancel: () => void;
  onSymbolSelect?: (selected: string) => void;
}

/**
 * The v2 ticket (or multi-leg ticket) the workspace order ticket already uses.
 * Hosts wrap this; they own chrome and store wiring.
 */
export const OrderTicketBody = ({
  symbol,
  legs,
  initialQuantity,
  onRemoveLeg,
  onUpdateLegType,
  onCancel,
  onSymbolSelect,
}: OrderTicketBodyProps) => {
  if (legs.length >= 2) {
    return (
      <MultiLegOrderTicketConnector
        underlyingSymbol={legs[0]?.contract.underlying_symbol ?? symbol ?? ""}
        legs={legs}
        onRemoveLeg={onRemoveLeg}
        onUpdateLegType={onUpdateLegType}
        fill
      />
    );
  }
  if (legs.length === 1) {
    return (
      <OrderTicket
        symbol={legs[0].contract.symbol}
        price={legs[0].price}
        quoteSide={legs[0].quoteSide}
        onCancel={onCancel}
        onSymbolSelect={onSymbolSelect}
        fill
        initialQuantity={initialQuantity}
      />
    );
  }
  return (
    <OrderTicket
      symbol={symbol}
      onSymbolSelect={onSymbolSelect}
      fill
      initialQuantity={initialQuantity}
    />
  );
};
